<template>
	<div class="contact">
		<div class="columns is-tablet">
			<div class="column is-6">
				<app-agent />
			</div>
			<div class="column is-6">
				<app-contact-form />
			</div>
		</div>
	</div>
</template>

<script>
	import Agent from '@/components/agent/agent.vue'
	import ContactForm from '@/components/contactForm/contactForm.vue'

	export default {
		components: {
			appAgent: Agent,
			appContactForm: ContactForm
		}
	}
</script>
